// extracted by mini-css-extract-plugin
export default {"instructionAndToolsController":"InstructionAndToolsController__instructionAndToolsController___WAci1"};